import * as locales from '@nuxt/ui/locale'

import { Locale } from '@/enums/locale'

/*
 * The @nuxt/ui locale for one of the console's languages: Nuxt UI's own texts (the calendar,
 * "no data", a dialog's close button) for `<UApp :locale>`. English is the British variant:
 * day before month in a date field, Monday first.
 */
export const uiLocaleFor = (code: string) => {
    switch (code) {
        case Locale.En: return locales.en_gb
        default:        return locales.sl
    }
}
